import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../styles/ModalRecordatorios.css";

export default function ModalRecordatorios({ clinica, onClose }) {

  const [citas, setCitas] = useState([]);
  const [seleccionadas, setSeleccionadas] = useState([]);
  const [clinicaFiltro, setClinicaFiltro] = useState(clinica || "ALL");

  const authConfig = {
    headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  };
  
  useEffect(() => {
    axios.get("/api/citas/recordatorios", {
      params: { clinica: clinicaFiltro },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(res => setCitas(res.data));
  }, [clinicaFiltro]);

  const cambiarEstado = (cita) => {
    const estados = ["PENDIENTE", "REALIZADO", "CANCELADO"];
    const next = estados[(estados.indexOf(cita.estadoAviso) + 1) % estados.length];

    axios.put(`/api/citas/${cita.citaId}/estado-aviso?estado=${next}`, {}, authConfig)
      .then(() => {
        setCitas(prev =>
          prev.map(c => c.citaId === cita.citaId ? { ...c, estadoAviso: next } : c)
        );
      });
  };

  const enviar = () => {
    axios.post("/api/recordatorios/enviar", {
      canal: "WHATSAPP",
      citas: seleccionadas
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(() => onClose());
  };

  const generarMensaje = (cita) => {
      const fecha = new Date(cita.fechaInicio).toLocaleDateString("es-ES");
      const hora = new Date(cita.fechaInicio).toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit"
      });
      const direccion =
        cita.clinica === "ELIPA"
          ? "Clínica Dental La Elipa\nC/ del Poeta Blas de Otero, 36\n28017 Madrid"
          : "Clínica Dental VEN\nAv. del Dr. García Tapia, 128\n28030 Madrid";

      return [
        `Hola ${cita.paciente},`,
        ``,
        `Le recordamos su cita en *${cita.clinica === "ELIPA" ? "Clínica Dental La Elipa" : "Clínica Dental VEN"}*`,
        `*${fecha}*`,
        `*${hora}*`,
        ``,
        direccion,
        ``,
        `Si no puede asistir, por favor avísenos con antelación.`,
        ``,
        `Muchas gracias.`
 
     ].join("\n");
  };

  const esManana = (fecha) => {
    const d = new Date(fecha);
    const manana = new Date();

    manana.setDate(manana.getDate() + 1);

    return (
      d.getFullYear() === manana.getFullYear() &&
      d.getMonth() === manana.getMonth() &&
      d.getDate() === manana.getDate()
    );
  };

  return (
    <div className="modal-overlay">
      <div className="modal-recordatorios">
        <header className="modal-header">
          <h3>Recordatorios de citas</h3>
          <div className="modal-header-actions">
            <select
              value={clinicaFiltro}
              onChange={e => setClinicaFiltro(e.target.value)}
              className="recordatorios-clinica-filter"
            >
              <option value="ALL">Todas</option>
              <option value="ELIPA">LA ELIPA</option>
              <option value="VEN">VEN</option>
            </select>
              <button onClick={onClose}>✕</button>
          </div>
        </header>

        <div className="modal-body">
          <table className="recordatorios-table">
            <thead>
              <tr>
                <th>Paciente</th>
                <th>Fecha</th>
                <th>Hora</th>
                <th>Móvil</th>
                <th>Telf. Fijo</th>
                <th>Email</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {citas.map(c => (
                  <tr
                    key={c.citaId}
                    className={
                      !esManana(c.fechaInicio)
                        ? "recordatorio-futuro"
                        : c.estadoAviso !== "REALIZADO"
                          ? "pendiente"
                          : ""
                    }
                  >
                  <td>
                    <div>{c.paciente}</div>
                    <small className="clinica-sub">{c.clinica}</small>
                  </td>
                  <td>{new Date(c.fechaInicio).toLocaleDateString()}</td>
                  <td>
                    {new Date(c.fechaInicio).toLocaleTimeString("es-ES", {
                      hour: "2-digit",
                      minute: "2-digit"
                    })}
                  </td>
                  <td>
                    {c.movil ? (
                      <a
                        href={`https://wa.me/34${c.movil}?text=${encodeURIComponent(generarMensaje(c))}`}
                        target="_blank"
                        rel="noreferrer"
                        className="movil-whatsapp-link"
                      >
                        {c.movil}
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td>{c.telefono || "-"}</td>
                  <td>{c.email || "-"}</td>
                  <td>
                    <span className={`estado-badge estado-${(c.estadoAviso || "PENDIENTE").toLowerCase()}`}
                      onClick={() => cambiarEstado(c)}
                    >
                      {c.estadoAviso || "PENDIENTE"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <footer className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Cancelar
          </button>
        </footer>

      </div>
    </div>
  );
}
